/*
 * Action Types
 */
export enum OperatorsTypes {
  LIST_OPERATOR_REQUEST = '@operators/LIST_OPERATOR_REQUEST',
  LIST_OPERATOR_SUCCESS = '@operators/LIST_OPERATOR_SUCCESS',
  LIST_OPERATOR_FAILURE = '@operators/LIST_OPERATOR_FAILURE',

  CREATE_OPERATOR_REQUEST = '@operators/CREATE_OPERATOR_REQUEST',
  CREATE_OPERATOR_SUCCESS = '@operators/CREATE_OPERATOR_SUCCESS',
  CREATE_OPERATOR_FAILURE = '@operators/CREATE_OPERATOR_FAILURE',

  UPDATE_OPERATOR_REQUEST = '@operators/UPDATE_OPERATOR_REQUEST',
  UPDATE_OPERATOR_SUCCESS = '@operators/UPDATE_OPERATOR_SUCCESS',
  UPDATE_OPERATOR_FAILURE = '@operators/UPDATE_OPERATOR_FAILURE',

  SELECT_OPERATOR_REQUEST = '@operators/SELECT_OPERATOR_REQUEST',
  SELECT_OPERATOR_SUCCESS = '@operators/SELECT_OPERATOR_SUCCESS',
  SELECT_OPERATOR_FAILURE = '@operators/SELECT_OPERATOR_FAILURE',
}

/*
 * Data types
 */

export interface SchoolSettings {
  id: string;
  paymentType: number;
  releaseType: number | null;
  creditExpirationLink: boolean;
  creditExpirationDays: number | null;
  createdAt: Date;
  updatedAt: Date;
  transportOperatorId?: string;
  SchoolSettingsSchool?: SchoolSettings;
  schoolSettingsId?: string;
  schoolId?: string;
}

export interface OperatorInterface {
  id: string;
  name?: string;
  SchoolSettings?: SchoolSettings[];
  type?: number;
}

/*
 * State type
 */
export interface OperatorsState {
  readonly operatorsList: OperatorInterface[];
  readonly operatorCreated: OperatorInterface;
  readonly operatorData: OperatorInterface;
  readonly operatorSelected: OperatorInterface;
  readonly loading: boolean;
  readonly error: boolean;
}
